import { Box, Grid } from "@mui/material";
import pxToRem from "theme/base/pxToRem";
import { useDispatch, useSelector } from "react-redux";
import {
  categoryOptionSelector,
  formFilterTimeKeepingHRSelector,
} from "modules/DeclareLeave/redux/selector";
import { useFormFlow, useFormUpdate, useRefsManager } from "helper/customHook";
import { formFilterTimeKeepingHRUpdate } from "modules/DeclareLeave/redux/formFilterTimeKeepingHR";
import FormSelect from "components/common/Form/FormSelect";
import { FormInput } from "components/common/Form";
import { memo } from "react";
import {
  getListTimeKeepingHRStart,
  resetListTimeKeepingHR,
} from "modules/DeclareLeave/redux/getListTimeKeepingHR";
import { resetControlPageFilter } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  CATEGORY_TYPE,
  getCategoryOptionStart,
} from "modules/DeclareLeave/redux/getCategoryOption";

const FilterTimeKeeping = memo(() => {
  const dispatch = useDispatch();
  const formData = useSelector(formFilterTimeKeepingHRSelector);
  const { DEPT_LEVEL1, DEPT_LEVEL2, JOB_TITLE, LEAVE_REASON, WORKING_AREA } =
    useSelector(categoryOptionSelector);

  const { attachRef, elementsRef } = useRefsManager();

  const handleFilter = () => {
    dispatch(resetListTimeKeepingHR());
    dispatch(resetControlPageFilter({ id: "timeKeepingHR", limit: 30 }));
    dispatch(getListTimeKeepingHRStart());
  };

  const { handleInputChange, handleSelectChange } = useFormUpdate(
    formFilterTimeKeepingHRUpdate,
    () => {
      handleFilter();
    }
  );

  const { handleNext } = useFormFlow(elementsRef, []);

  return (
    <Box sx={{ marginBlock: pxToRem(20) }}>
      <Grid container spacing={1}>
        <Grid item lg={2} md={4} sm={6} xs={6}>
          <FormSelect
            name={"workingAreaCode"}
            formData={formData}
            formErrors={{}}
            placeholder="Khu vực"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={WORKING_AREA || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6} xs={6}>
          <FormSelect
            name={"deptCodeLv1"}
            formData={formData}
            formErrors={{}}
            placeholder="Đơn vị cấp 1"
            // label="Người liên quan (nếu có)"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={(name) => (e) => {
              handleSelectChange(name)(e);
              dispatch(
                getCategoryOptionStart({
                  categoryType: CATEGORY_TYPE.DEPT_LEVEL2,
                  departmentCode: e,
                })
              );
            }}
            onKeyDown={(name: string) => handleNext(name)}
            options={DEPT_LEVEL1 || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6} xs={6}>
          <FormSelect
            name={"deptCodeLv2"}
            formData={formData}
            formErrors={{}}
            placeholder="Đơn vị cấp 2"
            // label="Người liên quan (nếu có)"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={DEPT_LEVEL2 || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6} xs={6}>
          <FormSelect
            name={"positionCode"}
            formData={formData}
            formErrors={{}}
            placeholder="Chức danh"
            // label="Người liên quan (nếu có)"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={JOB_TITLE || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6} xs={6}>
          <FormSelect
            name={"leaveReasonCode"}
            formData={formData}
            formErrors={{}}
            placeholder="Loại hình nghỉ"
            // label="Người liên quan (nếu có)"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={LEAVE_REASON || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6} xs={6}>
          <FormInput
            name={"searchText"}
            formData={formData}
            formErrors={{}}
            placeholder="Tìm nhân sự"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleInputChange}
            onKeyDown={(name: string) => handleNext(name)}
            inputProps={{ sx: { padding: pxToRem(10) } }}
            fontWeight={400}
            fontSize={14}
          />
        </Grid>
      </Grid>
    </Box>
  );
});
export default FilterTimeKeeping;
